import { GitMerge, Split, Hash, MapPin } from "lucide-react";

const liste = (arr) => arr.map((x) => x.name).join(", ").replace(/, ([^,]*)$/, " og $1");

const IKON = { samanslåing: GitMerge, deling: Split, kodeendring: Hash, namneendring: Hash };

const tekst = (e, kommuneName) => {
  if (e.type === "samanslåing")
    return `Slått saman i ${e.year}: ${e.name} vart danna av ${liste(e.fra)}. Tal frå før ${e.year} gjeld dei gamle kommunane kvar for seg, og er difor haldne utanfor historikken.`;
  if (e.type === "deling")
    return `Delt i ${e.year}: ${e.name} og ${liste(e.sysken)} var same kommune fram til ${e.year}. Tal frå før ${e.year} gjeld den gamle ${e.fra[0]?.name}-kommunen, og er difor haldne utanfor historikken.`;
  if (e.type === "kodeendring")
    return `Ny kommunekode i ${e.year}: ${kommuneName} gjekk frå kode ${e.gamal_kode} til ${e.kommune_code || ""}. Området er det same, så vi hentar eldre tal på den gamle koden.`;
  return `Nytt namn i ${e.year}: ${e.name}.`;
};

export const EndringarNotice = ({ data }) => {
  const endringar = (data?.endringar || []).filter((e) => e.type !== "namneendring");
  if (endringar.length === 0 && !data?.fylkesendring) return null;
  return (
    <div className="border border-[#E3D9C0] bg-[#FBF7EC] rounded-xl p-4 space-y-2" data-testid="endringar-notice">
      <p className="text-xs font-semibold uppercase tracking-[0.1em] text-[#8A7340]">Kommune- og fylkesendringar</p>
      <ul className="space-y-1.5">
        {endringar.map((e) => {
          const Icon = IKON[e.type] || Hash;
          return (
            <li key={`${e.year}-${e.type}`} className="flex items-start gap-2 text-xs text-[#4B4330]" data-testid={`endring-${e.type}-${e.year}`}>
              <Icon className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#B5832B]" />
              <span>{tekst({ ...e, kommune_code: data.kommune_code }, data.kommune_name)}</span>
            </li>
          );
        })}
        {data.fylkesendring && (
          <li className="flex items-start gap-2 text-xs text-[#4B4330]" data-testid="endring-fylke">
            <MapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#B5832B]" />
            <span>
              Fylkesendring i {data.fylkesendring.year}: kommunen gjekk frå {data.fylkesendring.fra} til {data.fylkesendring.til}. Fylkessnitt i
              appen er rekna ut frå dagens kommunar i fylket, slik at dei er samanliknbare bakover i tid.
            </span>
          </li>
        )}
      </ul>
      <p className="text-xs text-[#8A7340]" data-testid="endringar-grafmerke">
        Endringsåra er markerte med ei loddrett, stipla linje i historikkgrafane, slik at bruddet er synleg der tala står.
      </p>
      {data.samanliknbar_fra && (
        <p className="text-xs text-[#8A7340]" data-testid="endringar-samanliknbar">
          Tal for denne kommunen er samanliknbare frå {data.samanliknbar_fra} og framover. Eldre tal frå SSB gjeld eit anna område, og blir difor
          ikkje blanda inn.
        </p>
      )}
    </div>
  );
};

export const EndringarInline = ({ liste: endringar }) => {
  const med = (endringar || []).filter((k) => k.samanliknbar_fra);
  if (med.length === 0) return null;
  return (
    <p className="text-xs text-[#8A7340] bg-[#FBF7EC] border border-[#E3D9C0] rounded-lg px-3 py-2" data-testid="compare-endringar-note">
      Merk kommune- og fylkesendringar: {med.map((k) => `${k.kommune_name} er samanliknbar frå ${k.samanliknbar_fra}`).join(" · ")}. For desse
      kommunane startar historikken ved endringsåret, fordi eldre SSB-tal gjeld eit anna område.
    </p>
  );
};

export default EndringarNotice;
